import { defaultTimezone } from '@shared/datetime/datetime.utils';
import { DateRangeFilter } from '@shared/types/filter';
import { getDateTimeAsString, isDefined } from '@stillmandigital/common';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export function parseDateTimeString(value: string, timezone = defaultTimezone) {
  return dayjs.utc(dayjs.tz(value, timezone));
}

export function today() {
  return dayjs().toDate();
}

export function tomorrow() {
  return dayjs().add(1, 'day').toDate();
}

export function durationInDays(date: string | undefined) {
  if (!isDefined(date)) {
    return NaN;
  }

  return dayjs().diff(parseDateTimeString(date), 'day');
}

export function getDateRangeFilterForMonth(date = dayjs()): DateRangeFilter {
  return {
    fromTime: getDateTimeAsString(date.startOf('month').toDate(), '00:00:00'),
    toTime: getDateTimeAsString(date.endOf('month').add(1, 'day').toDate(), '00:00:00'),
  };
}

export function getTimeString(offset: number = 0): string {
  const adjustedDate = new Date(new Date().getTime() + offset);
  const hours = adjustedDate.getHours().toString().padStart(2, '0');
  const minutes = adjustedDate.getMinutes().toString().padStart(2, '0');
  const seconds = adjustedDate.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}
